import script from "./MusicConfigModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MusicConfigModal.vue?vue&type=script&setup=true&lang=js"

import "./MusicConfigModal.vue?vue&type=style&index=0&id=3033428e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3033428e"]])

export default __exports__